function Footer() {
  return (
    <footer className="footer">
      <h3>Foodie</h3>
      <p>© 2026 All rights reserved</p>
      <p>Contact: foodie12345@email.com</p>
    </footer>
  );
}

export default Footer;